import { BaseCard } from './BaseCard/BaseCard';
import { BasicCard } from './BasicCard/BasicCard';
import { TextOnlyCard } from './TextOnlyCard/TextOnlyCard';

import { Meta } from './components/Meta';
import { Title } from './components/Title';
import { Description } from './components/Description';
import { MetaInProgressBar } from './components/MetaInProgressBar';

export const DolCard = {
  Custom: BaseCard,
  Basic: BasicCard,
  TextOnly: TextOnlyCard,
};

export const DolCardUI = {
  Meta,
  Title,
  Description,
  MetaInProgressBar,
};
